import { HttpError } from '@/common/infrastructure/http/problemDetails';

/**
 * Prefer the Problem Details `detail` (the sentence the API wrote for the user) over
 * `Error.message`, which a transport error often sets to a status title.
 */
export function userFacingProblemMessage(err: unknown, fallback: string): string {
  if (err instanceof HttpError) {
    const detail = err.problem.detail?.trim();
    if (detail) return detail;
  }

  if (err instanceof Error && err.message.trim()) return err.message;
  return fallback;
}

/**
 * Only the sentence the API wrote for the user (Problem Details `detail`) reaches the screen; every
 * other failure (a network error, a status title such as "Internal Server Error", a bare "HTTP 500")
 * shows the caller's plain `fallback` instead of its transport text.
 */
export function problemDetailOrFallback(err: unknown, fallback: string): string {
  if (err instanceof HttpError) {
    const detail = err.problem.detail?.trim();
    if (detail) return detail;
  }
  return fallback;
}
